import React, { useState, useEffect } from 'react';

export default function Contact() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const details = [
    {
      icon: '📞',
      label: 'Phone / WhatsApp',
      value: '+91 98765 XXXX',
      sub: 'Call or message us anytime',
    },
    {
      icon: '✉️',
      label: 'Email',
      value: 'admissions@rscourses.edu',
      sub: 'We reply within 24 hours',
    },
    {
      icon: '🕐',
      label: 'Office Hours',
      value: 'Monday – Saturday',
      sub: '9:00 AM – 7:00 PM IST',
    },
  ];

  const courses = [
    {
      cat: 'Language & Communication',
      items: ['English Fluency', 'Basic English'],
    },
    {
      cat: 'Skill Development',
      items: ['Basic Computer', 'Graphic Designing'],
    },
  ];

  return (
    <section
      id="contact"
      style={{
        padding: isMobile ? '3rem 1rem' : '5rem 2rem',
        background: 'var(--bg)',
      }}
    >
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: '2rem' }}>
          <h2
            style={{
              fontSize: 'clamp(24px, 5vw, 46px)',
              fontWeight: '800',
              color: '#f0f4ff',
              marginBottom: '6px',
            }}
          >
            Get in touch <span style={{ color: '#0ff4c6' }}>with us</span>
          </h2>

          <p style={{ fontSize: '14px', color: '#94a3c4' }}>
            Our team is available 6 days a week.
          </p>
        </div>

        {/* Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: '1.5rem',
          }}
        >

          {/* LEFT - Contact Cards */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {details.map((d, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '14px',
                  padding: '14px 16px',
                  borderRadius: '14px',
                  background: 'var(--surface)',
                }}
              >
                {/* Icon */}
                <div
                  style={{
                    width: '42px',
                    height: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '10px',
                    background: 'rgba(15,244,198,0.1)',
                    fontSize: '20px',
                    flexShrink: 0,
                  }}
                >
                  {d.icon}
                </div>

                {/* Text */}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: '11px',
                      color: '#4a5878',
                      marginBottom: '2px',
                    }}
                  >
                    {d.label}
                  </div>

                  <div
                    style={{
                      fontSize: '14px',
                      color: '#fff',
                      fontWeight: '500',
                      lineHeight: 1.4,
                      wordBreak: 'break-word',
                    }}
                  >
                    {d.value}
                  </div>

                  <div style={{ fontSize: '12px', color: '#4a5878' }}>
                    {d.sub}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>

            {/* Courses */}
            <div
              style={{
                padding: '1.2rem',
                borderRadius: '16px',
                background: 'var(--surface)',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                  gap: '16px',
                }}
              >
                {courses.map((g, i) => (
                  <div key={i}>
                    <div
                      style={{
                        color: '#0ff4c6',
                        fontSize: '12px',
                        fontWeight: '600',
                        marginBottom: '6px',
                      }}
                    >
                      {g.cat}
                    </div>

                    {g.items.map((item, j) => (
                      <div
                        key={j}
                        style={{
                          fontSize: '13px',
                          color: '#94a3c4',
                          lineHeight: 1.6,
                        }}
                      >
                        • {item}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            {/* CTA */}
            <div
              style={{
                padding: '1.2rem',
                borderRadius: '14px',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'stretch' : 'center',
                justifyContent: 'space-between',
                gap: '12px',
                background: 'rgba(15,244,198,0.08)',
              }}
            >
              <div>
                <div style={{ fontWeight: '700', color: '#fff' }}>
                  Ready to start?
                </div>
                <div style={{ fontSize: '13px', color: '#94a3c4' }}>
                  Book a free demo
                </div>
              </div>

              <button
                style={{
                  width: isMobile ? '100%' : 'auto',
                  padding: '12px 18px',
                  borderRadius: '999px',
                  background: '#0ff4c6',
                  border: 'none',
                  fontWeight: '700',
                  cursor: 'pointer',
                }}
              >
                Book demo →
              </button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}